import React from 'react'
import { FormattedMessage } from 'react-intl';
import api from '../../../utils/API';
import './SSO-CMS.css'


class SSOForgotPassword extends React.Component {
    state = {
        email: '',
        error: '',
        success: false,
        submitted: false,
      }
    componentDidMount() {
    }
    handleSubmit = () => {
        this.setState({ submitted: true, error: '', success: ''});
        api.emailResetPassword({email: this.state.email})
          .then(res => {
            this.setState({ submitted: false, error: '', success: true});
        }).catch(err => {
            console.error(err)   
            let errMsg = '';         
            if(err.response && err.response.status === 400){
                errMsg = err.response.data;
              }else{
                errMsg = <FormattedMessage id="SERVER_ERROR"/>;
            }
            this.setState({ submitted: false, error: errMsg, success: false});
        })
    }
    render() {
        return(
            <div>
            {this.state.success ?
                <div className='card'>
                    <div className='header text-center'>
                        <h2><FormattedMessage id="FORGOT_PASSWORD" /></h2>
                    </div>
                    <div>
                        <FormattedMessage id="FORGOT_PASSWORD_EMAIL_SENT" values={{email: this.state.email}}/>
                    </div> 
                </div> :
                <div className='card'>
                    <div className='header text-center'>
                    <h2><FormattedMessage id="FORGOT_PASSWORD" /></h2>
                    </div>            
                    <div className='form-outline mt-2 mb-2'>
                        <label className='form-label' id='emailAddressLabel' htmlFor='form2Example1'><FormattedMessage id="EMAIL_ADDRESS" /></label>
                        <input className='form-control rounded-1' id='emailAddressField' value={this.state.email} name='email' type='email' onChange={(e) => this.setState({email: e.target.value})} />
                    </div>
                    {this.state.error ? <p className='error'><FormattedMessage id="ERROR" />{this.state.error}</p> : null}
                    <button type='button' className='btn btn-primary btn-block' onClick={this.handleSubmit} disabled={this.state.submitted}><FormattedMessage id="SUBMIT"/></button>
                    {/*<div className='mt-2 text-center'>
                            <label className='form-label red ms-2 label_hover' onClick={this.props.onSignIn}><FormattedMessage id="LOG_IN" /></label>
                    </div>*/}
                </div>
            }
            </div>
        )
    }
}

export default SSOForgotPassword;